import Column from '@/components/Column';
import Columns from '@/components/Columns';
import PageHeader from '@/components/PageHeader';

export function Empty() {
  return (
    <div className='min-w-screen flex min-h-screen flex-col px-2 pt-10'>
      <Column size={12} className='text-center'>
        <PageHeader
          title='Desculpe, mas não temos planos TIM disponíveis em seu estado.'
          dataIcTitle='sec-omega-comunicacao'
        />
      </Column>
      <Columns
        justifyContent='center'
        className='flex flex-1 items-center justify-center self-center pb-10 pt-4'
      >
        <img
          src='/tim_icon.png'
          alt='Logo da empresa TIM'
          className='h-24 animate-pulse'
        />
      </Columns>
    </div>
  );
}
